var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#A3A3A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3436 18.4184C12.1236 18.179 12 17.8543 12 17.5157C12 17.1771 12.1236 16.8524 12.3436 16.613L18.9823 9.38981C19.0906 9.26786 19.2201 9.17058 19.3633 9.10366C19.5064 9.03675 19.6604 9.00152 19.8163 9.00005C19.9721 8.99857 20.1266 9.03088 20.2708 9.09508C20.4151 9.15928 20.5461 9.25409 20.6563 9.37398C20.7665 9.49387 20.8536 9.63643 20.9126 9.79335C20.9716 9.95027 21.0013 10.1184 21 10.2879C20.9986 10.4575 20.9662 10.625 20.9047 10.7808C20.8432 10.9366 20.7538 11.0775 20.6417 11.1953L14.8327 17.5157L20.6417 23.8361C20.8555 24.0769 20.9738 24.3995 20.9711 24.7342C20.9684 25.069 20.845 25.3893 20.6274 25.626C20.4099 25.8628 20.1155 25.997 19.8078 26C19.5001 26.0029 19.2037 25.8742 18.9823 25.6416L12.3436 18.4184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4104530eb030d30061b8216a3c9514e6.svg";
export { ForwardRef as ReactComponent };